import { usePixiMouseEventListener } from "./usePixiMouseEventListener.js";
export const usePixiOnClickOutside = (ref, action) => {
    usePixiMouseEventListener((event) => {
        if (ref.current?.eventMode !== "none" && !ref.current?.getBounds().containsPoint(event.clientX, event.clientY)) {
            action(event);
        }
    }, undefined, true);
};
//# sourceMappingURL=usePixiOnClickOutside.js.map